export const COLORS = {
  blue: '#4A7EB5',
  blueLight: '#5B8CB8',
  blueDark: '#3A6A9A',
  background: '#0F1923',
  surface: '#1A2B3C',
  surfaceLight: '#243447',
  border: '#2D4259',
  textPrimary: '#FFFFFF',
  textSecondary: '#8FA8C0',
  textMuted: '#4A6580',
  success: '#10B981',
  warning: '#F59E0B',
  error: '#EF4444',
  white: '#FFFFFF',
};

export const LEAD_STATUSES = [
  { key: 'nh1', label: 'Not Home', short: 'NH1', color: '#E8820C', icon: '🚪' },
  { key: 'nh2', label: 'Not Home 2', short: 'NH2', color: '#8B5CF6', icon: '🚶' },
  { key: 'nh3', label: 'Not Home 3', short: 'NH3', color: '#EC4899', icon: '❌' },
  { key: 'gb', label: 'Go Back', short: 'GB', color: '#10B981', icon: '↩️' },
  { key: 'cb', label: 'Callback', short: 'CB', color: '#F59E0B', icon: '📞' },
  { key: 'app', label: 'Appointment', short: 'APP', color: '#3B82F6', icon: '📅' },
  { key: 'ld', label: 'Lead', short: 'LD', color: '#1E40AF', icon: '👍' },
  { key: 'sold', label: 'Sold', short: 'SOLD', color: '#059669', icon: '💰' },
];

export const STAGE_COLORS: Record<string, string> = {
  'New Lead': '#64748B',
  'Verify Claim Number/Checklist': '#F59E0B',
  'Adjuster Meeting': '#10B981',
  'Initial Insurance Estimate': '#3B82F6',
  'Order EagleView': '#4A7EB5',
  'Supplement': '#EC4899',
  'Appraisal': '#EC4899',
  'Full Approval': '#10B981',
  'Project Design': '#8B5CF6',
  'Signed Contract': '#10B981',
  'Material Order': '#F59E0B',
  'Schedule Labor': '#3B82F6',
  'Dumpster Delivery': '#F97316',
  'Job In Progress': '#EF4444',
  'Completion Review': '#10B981',
  'Pay Labor': '#8B5CF6',
  'Final Invoice': '#F59E0B',
  'Pending Payment': '#F59E0B',
  'Sold': '#10B981',
  'Deposit Received': '#10B981',
  'Scheduled': '#3B82F6',
  'In Progress': '#EF4444',
  'Job Complete': '#10B981',
  'Paid and Closed': '#10B981',
  'Commission Paid': '#8B5CF6',
  'Lost': '#EF4444',
  'Closed': '#4A6580',
};
